import api from '@api'

export function gerateCaptchaApi(id) {
  return api.get('/public/generate/captcha')
}
